<template>
  <div id="bio-top-bar">
    <!-- <div v-show="close70years" style="position: relative;">
      
      <i
        @click="close_year70()"
        style="position: absolute;top:15px; right: 15px;z-index: 10;color:#FF8379;font-size:30px"
        class="el-icon-close"
      ></i>
      <el-image @click="showNotice()" :src="serve + year70" style="width:100%;height:60px;"></el-image>
    </div>-->
    <div class="clearfix top_class">
      <!--新年头部 -->
      <!-- :class="newYear?'new_year' : ''" -->
      <!-- <div class="new_year_div" v-if="newYear">
        <div class="new_year_img" v-for="item in new_year_top" :key="item">
          <img src="https://www.bioflin.com:83/image/newyear/newyear0.png" alt />
        </div>
      </div>-->
      <div class="container" id="element">
        <div class="clear">
          <div class="right-item2 float-item">
            <i class="el-icon-phone"></i>
            400-821-3401
          </div>
          <div>
            <el-popover placement="top-start" width="200" trigger="hover">
              <div>
                <div class="top_code clearfix">
                  <div class="top_code_img">
                    <el-image class="top_code_img1" :src="serve+miniCode" :fit="fit"></el-image>
                  </div>
                  <div class="top_code_text">
                    <div class="top_code_text1">微信小程序</div>
                    <div class="top_code_text2">扫一扫 更方便</div>
                    <div style="margin-top:10px">
                      <!-- <el-image :src="serve+qrCodeIcon" :fit="fit"></el-image> -->
                      <img :src="serve+qrCodeIcon" alt />
                    </div>
                  </div>
                </div>
                <div class="top_code clearfix">
                  <div class="top_code_img">
                    <el-image class="top_code_img1" :src="serve+appCode" :fit="fit"></el-image>
                    <!-- <img class="top_code_img1" :src="serve+appCode" alt=""> -->
                  </div>
                  <div class="top_code_text">
                    <div class="top_code_text1">手机APP</div>
                    <div class="top_code_text2">新人专享大礼包</div>
                  </div>
                </div>
                <div class="top_code clearfix">
                  <div class="top_code_img">
                    <el-image class="top_code_img1" :src="serve+gzhCode" :fit="fit"></el-image>
                  </div>
                  <div class="top_code_text">
                    <div class="top_code_text1">微信公众号</div>
                    <div class="top_code_text2">微信扫一扫关注宝枫林服务号订阅更多促销优惠福利</div>
                  </div>
                </div>
              </div>
              <router-link slot="reference" to="/" class="right-item float-item">
                <div class="app_store">
                  掌上商城
                  <div class="app_store_img">
                    <el-image style="width: 100px; height: 100px" :src="serve + service" :fit="fit"></el-image>
                  </div>
                </div>
              </router-link>
            </el-popover>
          </div>

          <router-link to="/join" class="right-item float-item">招商入口</router-link>
          <router-link to="/help/8" class="right-item float-item">帮助中心</router-link>
          <router-link to="/user/home/0" class="right-item float-item" v-if="isLogin==true">个人中心</router-link>
          <router-link to="/user/orders/1" class="right-item float-item" v-if="isLogin==true">我的订单</router-link>
          <router-link to="/register" class="right-item float-item" v-if="isLogin==false">免费注册</router-link>
          <router-link to="/login" class="right-item float-item" v-if="isLogin==false">立即登录</router-link>
          <span @click="logout" v-if="isLogin==true" class="right-item float-item">退出登录</span>
          <span v-if="isLogin==true" class="right-item float-item helo">Hi,{{isLogin_monile}}</span>
        </div>
      </div>
    </div>
    <div class="search-bar">
      <div class="container">
        <div>
          <el-row>
            <el-col :span="5">
              <router-link to="/" tag="div" class="topLogo">
                <img :src="serve + '/logo.png'" />
              </router-link>
            </el-col>
            <el-col :span="11">
              <div style="margin-top:30px;">
                <el-autocomplete
                  id="autocomplete"
                  :autofocus="isAutofocus"
                  v-model="keywords"
                  :fetch-suggestions="autoComplete"
                  placeholder="请输入商品名称或者货号"
                  @select="handleSelect"
                  style="width:500px"
                  @keyup.enter.native="search()"
                  ref="iptt"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  <template slot="append">
                    <el-button @click="search">
                      <div style="height:100%;width:100%;">搜索</div>
                    </el-button>
                  </template>
                </el-autocomplete>
              </div>
              <div style="margin-top:5px;padding-left:15px;">
                <router-link
                  class="words-item"
                  :to="'/results?keywords='+item"
                  v-for="(item,index) of words"
                  :key="index"
                >
                  <el-link>{{item}}</el-link>
                </router-link>
              </div>
            </el-col>
            <el-col :span="4" :offset="3">
              <el-popover placement="top-start" width="310" trigger="hover">
                <div class="car_shopping">
                  <div
                    v-if="count>0"
                    class="cartDialogue"
                    :class="carts.length > 5 ? 'cartDialogue1' :'' "
                  >
                    <div class="cartDialogue_top">最近加入的商品</div>
                    <div class="car_list" v-for="(item,index) of carts" :key="index">
                      <div class="img">
                        <img
                          style="width:50px;height:50px"
                          :src="serve + '/'+item.cover"
                          class="cover"
                        />
                      </div>

                      <div class="title">
                        <div
                          class="title_div1 title_div5"
                        >{{item.title.length>8? item.title.substr(0,8) + '...' : item.title}}</div>
                        <div>
                          <span class="title_div2">{{item.item_no}}</span>
                          <span class="title_div3" style="color:#666666">x {{item.number}}</span>
                        </div>
                      </div>
                      <div class="money title">
                        <div
                          style="color:#E2211C;text-align:right;white-space:nowrap;"
                        >&yen;{{item.selling_price}}</div>
                        <div class="title_div4" @click="delItem(item.id)">删除</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="count>0" class="go_shopping">
                    <div>
                      共
                      <span style="font-weight:bold">{{count}}</span>
                      件商品
                    </div>
                    <div>
                      <el-button type="primary" size="medium" @click="goCart">去购物车</el-button>
                    </div>
                  </div>
                  <div
                    v-else-if="count==0"
                    class="lv3Text"
                    style="padding:10px;text-align:center"
                  >购物车内没有商品</div>
                </div>
                <div slot="reference" @mouseleave="closeCart()" v-show="isLogin === true">
                  <div style="margin-top:30px;" @mouseenter="showCart()">
                    <el-button class="cart" @click="mycar()">
                      <i
                        class="iconfont icon-shopping"
                        style="color:#e2211c;margin-right:5px;font-size:20px"
                      ></i>
                      <el-badge :hidden="!count>0" :value="count" type="primary">
                        <div style="width:84px;line-height:20px;">我的购物车</div>
                      </el-badge>
                    </el-button>
                  </div>
                </div>
                <!-- <div slot="reference" v-else>
                  <br />
                </div>-->
              </el-popover>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="container topM2" @mouseleave="leave">
      <div class="clear">
        <div class="header" style="float:left;margin-top:-40px" @mousemove="show = true">全部分类</div>
        <div style="margin-left:230px;float:left;margin-top:-30px">
          <div class="item" :class="itemchnage1 == '1'? 'itemchnage' : ''" style="float:left;">
            <el-link type="primary" :underline="false">
              <el-link type="primary" :underline="false">
                <router-link to="/">首页</router-link>
              </el-link>
            </el-link>
          </div>
          <div class="item" :class="itemchnage1 == '2'? 'itemchnage' : ''" style="float:left">
            <el-link type="primary" :underline="false">
              <router-link to="/limit">限时折扣</router-link>
            </el-link>
          </div>
          <div class="item" :class="itemchnage1 == '3'? 'itemchnage' : ''" style="float:left">
            <el-link type="primary" :underline="false">
              <router-link to="/group_index">团购</router-link>
            </el-link>
          </div>
          <div class="item" :class="itemchnage1 == '4'? 'itemchnage' : ''" style="float:left">
            <el-link type="primary" :underline="false">
              <el-link type="primary" :underline="false">
                <router-link to="/user/couponCenter">优惠券</router-link>
              </el-link>
            </el-link>
          </div>
          <div class="item" :class="itemchnage1 == '5'? 'itemchnage' : ''" style="float:left">
            <!-- <el-link type="primary" :underline="false">
              <el-link type="primary" :underline="false">
                <router-link to="/news">BioflinNews</router-link>
              </el-link>



            </el-link>-->
            <el-link type="primary" :underline="false">
              <el-link type="primary" :underline="false">
                <a
                  href="http://russian.chromatography-resin.com/"
                  class="link"
                  target="_blank"
                >PreventionProduct</a>
              </el-link>
            </el-link>
          </div>
          <div class="item" :class="itemchnage1 == '6'? 'itemchnage' : ''" style="float:left">
            <el-link type="primary" :underline="false">
              <el-link type="primary" :underline="false">
                <router-link to="/user/points">积分商城</router-link>
              </el-link>
            </el-link>
          </div>
          <!-- <div class="item" :class="itemchnage1 == '7'? 'itemchnage' : ''" style="float:left">
            <el-link type="primary" :underline="false">
              <el-link type="primary" :underline="false">
                <router-link to="/share_index">资源共享</router-link>
              </el-link>
            </el-link>
          </div>
          <div class="item" :class="itemchnage1 == '8'? 'itemchnage' : ''" style="float:left">
            <el-link type="primary" :underline="false">
              <el-link type="primary" :underline="false">
                <router-link to="/shop/shopList">旗舰店</router-link>
              </el-link>
            </el-link>
          </div>

          <div class="item" :class="itemchnage1 == '9'? 'itemchnage' : ''" style="float:left">
            <el-link type="primary" :underline="false">
              <el-link type="primary" :underline="false">
                <router-link to="/patent_index">专利交易</router-link>
              </el-link>
            </el-link>
          </div>-->

          <div class="item" :class="itemchnage1 == '10'? 'itemchnage' : ''" style="float:left">
            <el-link type="primary" :underline="false">
              <el-link type="primary" :underline="false">
                <router-link to="/bioLook_index">宝枫林寻源</router-link>
              </el-link>
            </el-link>
          </div>
        </div>
      </div>
      <el-collapse-transition>
        <div style="position: absolute" class="trans" v-if="show||isHome">
          <div class="cate-menu1" @mousemove="show=true">
            <div v-for="(item,index) of cate" :key="index" @mousemove="hoverId=index">
              <router-link class="item" :to="'/results?topClass='+item.cate_name">
                <span
                  style="font-weight: 800;color:#333"
                >{{item.cate_name.slice(0,item.cate_name.indexOf('/'))}}</span>
                {{item.cate_name.slice(item.cate_name.indexOf('/'))}}
              </router-link>
            </div>
          </div>
          <div class="cate-menu2" @mousemove="show=true" v-if="hoverId!=null">
            <div v-for="n in 11" :key="n">
              <div v-if="hoverId==n-1&&show">
                <el-row>
                  <el-col :span="19">
                    <div v-if="cate[0]">
                      <div
                        v-for="(item2,index2) of cate[n-1].data"
                        :key="index2"
                        style="margin-bottom:8px;"
                      >
                        <router-link
                          :to="'/results?SecondClass='+item2.id"
                          style="font-weight:bold"
                        >{{item2.cate_name}}</router-link>
                        <i class="fas fa-angle-right" style="margin:0 8px;"></i>
                        <span v-for="(item3,index3) of item2.data" :key="index3">
                          <router-link
                            :to="'/results?ThirdClass='+item3.id"
                            style="margin-bottom:5px;display:inline-block"
                          >{{item3.cate_name}}</router-link>
                          <el-divider direction="vertical"></el-divider>
                        </span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="5">
                    <div
                      style="background-color:rgb(221,221,221);padding: 10px 0"
                      v-if="rightAd[0]"
                    >
                      <el-row style="margin-bottom:10px;">
                        <el-col :span="12" v-for="n2 in 8" :key="n2">
                          <div
                            v-if="rightAd[n-1]&&rightAd[n-1]['brand'+(n2-1)]"
                            style="padding:1px;"
                          >
                            <router-link :to="'viewBrands?id=' + rightAd[n-1]['brand'+(n2-1)].id">
                              <img
                                :src=" serve + '/'+rightAd[n-1]['brand'+(n2-1)].logo_thumb"
                                style="width:100%;height:52px;"
                              />
                            </router-link>
                          </div>
                        </el-col>
                      </el-row>
                      <div v-if="rightAd[n-1]['image1']">
                        <router-link :to="rightAd[n-1]['link1']">
                          <img
                            :src=" serve + '/'+rightAd[n-1]['image1']"
                            style="width:90%;margin: 3px auto;height:109px"
                          />
                        </router-link>
                      </div>
                      <div v-if="rightAd[n-1]['image2']">
                        <img
                          :src=" serve + '/'+rightAd[n-1]['image2']"
                          style="width:90%;margin: 0 auto;height:109px"
                        />
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <el-dialog
      :visible.sync="year70Notice"
      width="440px"
      :show-close="false"
      top="30vh"
      style="padding:0"
    >
      <el-image :src="serve + year70NoticeUrl"></el-image>
      <i
        @click="close_year70Notice()"
        style="position: absolute;top:-5px; right: -30px;z-index: 10;color:#999999;font-size:30px"
        class="el-icon-close"
      ></i>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo);
import $ from "jquery";
import { setTimeout, setInterval } from "timers";
export default {
  data() {
    return {
      new_year_top: 1,
      newYear: false,
      serve: this.$store.state.serve,
      showQRcode: false,
      appCode: "/wechat/qrCode/appCode.jpg",
      gzhCode: "/wechat/qrCode/gzhCode.jpg",
      miniCode: "/wechat/qrCode/miniCode2.jpg",
      qrCodeIcon: "/wechat/qrCode/qrCodeIcon.jpg",
      service: "/webInfo/official_wx.jpg",
      fit: "cover",
      isleftList: 0,
      isLi: null,
      isLogin_monile: "",
      isAutofocus: false,
      itemchnage1: null,
      words: null,
      show: false,
      hoverId: null,
      lock: false,
      auto: false,
      keywords: "",
      cart_show: true,
      count: null,
      total: 0,
      cartDialogue: true,
      carts: [],
      isLogin: null,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      autoWords: {},
      cate: null,
      rightAd: [],
      isHome: false,
      year70: "/bannerAD/70year.jpg",
      close70years: true,
      year70Notice: false,
      year70NoticeUrl: "/bannerAD/70yearnotice.jpg"
    };
  },
  created() {
    if (this.$cookies.get("close_year70")) {
      this.close70years = false;
    }
    if (this.$route.path == "/results") {
      this.keywords = this.$route.query.keywords;
    }
    // const params = this.$route.fullPath.indexOf("?");
    // if (this.$route.fullPath == "/" || params !== -1) {
    //   this.isHome = true;
    // }
    this.axios.get(this.serve + "/search_hot?a=1").then(res => {
      this.words = res.data.data;
    });

    this.axios.get(this.serve + "/category_ad_image").then(res => {
      for (var item of res.data.data) {
        this.rightAd.push(item);
      }
    });

    this.axios.get(this.serve + "/get_category").then(res => {
      this.cate = res.data;
      this.$store.commit("setMenu", res.data);
    });
    this.loadCart();
    this.axios
      .get(this.serve + "/isLogin", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token")
        }
      })
      .then(res => {
        if (res.data.data == 1) {
          this.$store.state.isLogin = true;
          this.isLogin = true;
        } else {
          this.$store.state.isLogin = false;
          this.isLogin = false;
          // this.$cookies.remove("token");
          // this.$cookies.remove("user");
        }
      });
  },
  activated() {
    //
    // newYear
    if (this.$route.path == "/") {
      this.newYear = true;
      var w = document.documentElement.scrollWidth || document.body.scrollWidth;
      this.new_year_top = parseInt(w / 34) + 1;
    }

    //
    const pathFrom = this.$route.fullPath;
    const params = pathFrom.indexOf("/?user_from");
    const Path = pathFrom.indexOf("/product");
    if (this.$route.fullPath == "/" || params !== -1) {
      this.isHome = true;
    }
    // if(pathFrom.indexOf('/product') !==-1 ){
    //   this.isHome = false;
    // }
    if (this.$cookies.get("token") && this.$cookies.get("user")) {
      this.$store.state.isLogin = true;
      this.isLogin = true;
      this.heading();
    }
    // this.iEVersion()
  },
  methods: {
    //判断浏览器版本
    /*
    iEVersion() {
      var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
      var isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; // 判断是否IE<11浏览器
      var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; // 判断是否IE的Edge浏览器
      var isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
      if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion === 7) {
          console.log(7)
          // return 7;
        } else if (fIEVersion === 8) {
          console.log(8)
          // return 8;
        } else if (fIEVersion === 9) {
           console.log(9)
          // return 9;
        } else if (fIEVersion === 10) {
           console.log(10)
          // return 10;
        } else {
           console.log(6)
          return 6; // IE版本<=7
        }
      } else if (isEdge) {
         console.log('edge')
        return "edge"; // edge
      } else if (isIE11) {
         console.log(11)
        return 11; // IE11
      } else {
        console.log(false)
        return -1; // 不是ie浏览器
      }
    },
    */

    showNotice() {
      this.year70Notice = true;
    },
    close_year70() {
      this.$cookies.set("close_year70", 1, { expires: 1 });
      this.close70years = false;
    },
    close_year70Notice() {
      this.year70Notice = false;
    },
    isShowQRcode() {
      this.showQRcode = true;
    },
    isHideQRcode() {
      this.showQRcode = false;
    },
    help() {
      this.$router.push({
        path: "/help/8"
      });
    },
    mycar() {
      this.$router.push({
        path: "/user/cart"
      });
    },
    heading() {
      this.axios
        .get(this.serve + "/head_and_bindmobile", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.isLogin_monile = res.data.data.bind_mobile;
          }
        });
    },
    leave() {
      this.show = false;
      this.hoverId = null;
    },
    handleSelect() {},
    autoComplete(queryString, cb) {
      this.axios
        .get(this.serve + "/autocomplete", {
          params: {
            keywords: queryString,
            mobile: this.$cookies.get("user")
          }
        })
        .then(res => {
          for (var item of res.data) {
            item.value = item.title;
          }
          cb(res.data);
        });
    },
    goAuto(v) {
      this.auto = false;
      this.lock = true;
      this.keywords = v;
      this.$router.push("/results?keywords=" + v);
    },
    set1(v) {
      // this.itemchnage1 = v.path;
      if (this.$route.fullPath == "/") {
        // this.isLogin = true
        // this.heading()
        this.isHome = true;
      } else {
        this.isHome = false;
      }
      if (this.$route.query.keywords) {
        this.keywords = this.$route.query.keywords;
      } else {
        this.keywords = "";
      }
    },
    go1() {
      this.$router.push("/user/home");
    },
    logout() {
      this.$cookies.remove("token");
      this.$cookies.remove("user");
      this.$router.push("/");
      window.location.reload();
    },
    closeCart() {
      // this.cartDialogue = false;
      // this.carts = null;
    },
    showCart() {
      // this.cartDialogue = true;
      this.loadCart();
    },
    delItem(id) {
      var that = this;
      this.axios
        .get(this.serve + "/member/del_car", {
          params: {
            mobile: this.mobile,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          that.loadCart();
        });
    },
    goCart() {
      this.$router.push("/user/cart");
      this.cartDialogue = false;
    },
    clearCart() {
      this.carts = [];
    },
    search() {
      if (this.keywords != "") {
        this.auto = false;
        this.$router.push({
          path: "/results",
          query: {
            keywords: this.keywords,
            random: Math.round(Math.random() * 100)
          }
        });
      }
      this.$refs.iptt.focus();
    },
    loadCart() {
      var that = this;
      this.axios
        .get(this.serve + "/member/get_car_three", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.msg == "搜索结果为空") {
            that.carts = [];
            that.count = 0;
            that.total = 0;
          } else if (res.data.results) {
            that.carts = res.data.results;
            that.count = res.data.count;
            that.total = res.data.money;
            that.$store.commit("set", res.data.count);
            for (var item of that.carts) {
              var img = item.images.split(";");
              item.cover = img[0];
            }
          }
        });
    }
  },
  watch: {
    "$store.state.top_nav": {
      handler: function(newer, older) {
        this.itemchnage1 = newer;
      },
      deep: true
    },
    "$store.state.menu": {
      handler: function(v) {
        this.cate = v;
      }
    },
    "$store.state.cart_show": {
      handler: function(newer, older) {
        this.cart_show = newer;
      },
      deep: true
    },
    "$store.state.cart_count": {
      handler: function(newer, older) {
        this.count = newer;
      },
      deep: true
    },
    $route: "set1"
  }
};
</script>

<style lang="scss">
.car_shopping {
  width: 100%;
  .cartDialogue1 {
    height: 400px;
    overflow: scroll;
    overflow-x: auto;
  }
  .cartDialogue {
    // height: 400px;
    // overflow: scroll;
    // overflow-x: auto;
    .cartDialogue_top {
      font-size: 12px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 12px;
    }
    .car_list:hover {
      background: rgba(245, 245, 245, 1);
      color: #e2211c;
    }
    .car_list {
      height: 70px;
      background: #fff;
      width: 100%;
      border-bottom: 1px dashed rgba(221, 221, 221, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      .img {
        width: 50px;
        height: 50px;
        background: rgba(204, 204, 204, 1);
        border: 1px solid rgba(204, 204, 204, 1);
      }

      .title {
        font-family: "Microsoft YaHei";
        font-weight: 400;
        .title_div1 {
          font-size: 14px;

          // color: rgba(226, 33, 28, 1);
        }

        .title_div5 {
          width: 140px;
        }
        .title_div2 {
          font-size: 12px;
          // color: rgba(226, 33, 28, 1);
        }
        .title_div3 {
          font-size: 12px;
          margin-left: 30px;
        }
        .title_div4 {
          text-align: right;
          color: #999999;
          cursor: pointer;
        }
        .title_div4:hover {
          color: #333333;
        }
      }
      .money {
        width: 70px;
      }
    }
  }
  .go_shopping {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    height: 48px;
    background: rgba(245, 245, 245, 1);
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.app_store {
  position: relative;
  .app_store_img {
    position: absolute;
    top: 50px;
    left: 0;
  }
}
.top_code {
  // border-bottom: 1px solid #dddddd;
  margin-bottom: 10px;
  // justify-content: space-between;
  // align-items: center;
  > div {
    float: left;
    margin-right: 4px;
  }
  .top_code_img {
    width: 110px;
    height: 110px;
    border: 1px solid #dddddd;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    .top_code_img1 {
      display: block;
      margin: 5px auto 0 auto;
      width: 100px;
      height: 100px;
    }
  }
  .top_code_text {
    width: 80px;
    .top_code_text1 {
      line-height: 20px;
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
    }
    .top_code_text2 {
      font-size: 12px;
      font-family: "Microsoft YaHei";
      color: rgba(226, 33, 28, 1);
      line-height: 20px;
    }
  }
}
#bio-top-bar {
  .top_class {
    background: #e8e8e8;
  }

  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    padding: 0;
  }
  .QRcode-item {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    background-color: #fff;
    border-left: #ddd 1px solid;
    border-right: #ddd 1px solid;
    border-bottom: #ddd 1px solid;
    width: 65%;
    display: flex;
    // justify-content: space-around
  }
  .oneQRcode {
    position: absolute;
    top: -10px;
    left: 220px;
    padding: 4px;
    background-color: white;
    border: #dddddd 1px solid;
  }
  .triangle {
    margin-left: 30px;
    width: 0;
    height: 0;
    border: 5px solid;
    border-color: transparent transparent white;
  }
  .el-col-offset-3 {
    margin-left: 0px;
  }
  .words-item {
    margin-right: 5px;
  }
  .cate-menu1 {
    position: absolute;
    .item {
      display: block;
      position: relative;
      z-index: 99;
      line-height: 30px;
      height: 30px;
      background-color: #fff;
      padding-left: 20px;
      width: 180px;
      cursor: pointer;
    }
    .item:hover {
      background-color: #ddd;
    }
  }
  .cate-menu2 {
    a:hover {
      color: #e2211c;
    }
    background-color: #fff;
    position: relative;
    left: 200px;
    width: 960px;
    z-index: 99;
    padding: 10px 20px;
    min-height: 310px;
  }
  .topM2 {
    z-index: 100;
    // .trans {
    //   transition: 3s;
    // }
    .item {
      a {
        color: #333;
        margin: 0 6px;
      }
      a:hover {
        color: #e2211c;
      }
    }
    .itemchnage {
      a {
        color: #e2211c;
      }
    }
    .header {
      position: relative;
      cursor: pointer;
      background-color: #e2211c;
      color: #fff;
      width: 200px;
      line-height: 40px;
      text-align: center;
    }
  }
  .topLogo {
    background-color: #fff;
    padding: 20px;
    width: 160px;
    text-align: center;
    position: relative;
    top: -40px;
    cursor: pointer;
    > img {
      width: 120px;
      height: 120px;
      display: block;
      margin: 0 auto;
      *zoom: 1;
      *display: inline;
    }
  }
  .cmd-words {
    color: #999;
    font-size: 12px;
    margin: 5px 10px;
  }
  .cmd-words:hover {
    text-decoration: underline;
  }
  background-color: rgb(245, 245, 245);
  .autocomplete {
    position: absolute;
    background: #fff;
    float: left;
    z-index: 10;
    width: 455px;
    box-shadow: 5px 5px 5px rgba($color: #000000, $alpha: 0.3);
    font-size: 13px;
  }
  .auto-item {
    padding: 5px 10px;
    cursor: pointer;
  }
  .auto-item:hover {
    color: #e2211c;
  }
  .top-cate {
    display: inline-block;
    padding: 0 20px;
    a {
      line-height: 36px;
      text-align: center;
    }
    a:hover {
      text-decoration: underline;
    }
  }
  .all-cate {
    background-color: #e2211c;
    a {
      color: #fff;
      width: 200px;
      display: inline-block;
      line-height: 36px;
      text-align: center;
      letter-spacing: 0.2em;
    }
  }
  .bot-menu {
    // background-color: #fff;
    font-size: 15px;
    margin-top: 20px;
  }
  .el-dropdown-link {
    font-size: 12px;
    color: #999;
  }
  .el-input__inner {
    border-radius: 20px 0 0 20px;
  }
  .el-input-group__append {
    border-radius: 0 20px 20px 0;
  }
  .fa-times {
    cursor: pointer;
    color: #c0c4cc;
  }
  .fa-times:hover {
    color: #606266;
  }
  .l1 {
    margin-bottom: 10px;
  }

  .el-icon-loading {
    font-size: 20px;
    margin: 10px 0;
  }
  .cart {
    border-radius: 20px;
  }
  .m1 {
    transition: 0.3s;
  }
  .m1:hover {
    color: #8cbe29;
  }
  .cart {
    display: block;
    width: 150px;
  }
  .el-input-group__append {
    background-color: #e2211c;
    color: #fff;
    cursor: pointer;
  }

  .search-bar {
    background-color: rgb(245, 245, 245);
    height: 160px;
  }
  .left-item {
    float: left;
    color: #666;
    svg {
      margin-right: 5px;
    }
  }
  .right-item {
    float: right;
    color: #999;
    padding: 0 10px;
    cursor: pointer;
  }
  .right-item2 {
    float: right;
    color: #999;
    padding: 0 10px;
  }
  .right-item:hover {
    text-decoration: underline;
    color: #777;
  }
  .float-item {
    line-height: 35px;
    font-size: 12px;
  }
  .helo {
    color: #e2211c;
  }
  .new_year {
    background: #d00313;
    position: relative;
    .new_year_div {
      position: absolute;
      width: 100%;
      top: 0;
      white-space: nowrap;
      overflow: hidden;
    }
    a {
      color: #fff;
    }
    span {
      color: #fff;
    }
    .right-item2 {
      color: #fff;
    }
    .new_year_img {
      /* float: left; */
      display: inline-block;
      /* height: 5px; */
    }
  }
}
</style>